import { Message } from '../types';
import { Box, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { containerMessage, container, messageAfter } from './styles';
import useStore from '~/store';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  questionComponent?: Message['questionComponent'];
  Component?: Message['Component'];
}

const CONTINENTS = [
  {
    value: 2,
    label: 'América do Sul e América Central'
  },
  {
    value: 3,
    label: 'América do Norte e Europa'
  },
  {
    value: 4,
    label: 'África, Ásia, Oceania e Antártida'
  },
  {
    value: 5,
    label: 'Qualquer Continente'
  }
];

export const WhichContinents = ({ content: _content }: Props) => {
  const { setContinents, quote } = useStore((store) => ({
    quote: store.quote,
    setContinents: store.setContinents
  }));

  const { continents } = quote;

  const handleContinentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContinents(Number(event.target.value));
  };

  return (
    <Box sx={container}>
      <Box sx={() => containerMessage()}>
        <FormControl>
          <RadioGroup aria-labelledby="radio-button-competitions" value={continents} onChange={handleContinentChange}>
            {CONTINENTS.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                control={
                  <Radio inputProps={{ 'aria-label': label }} checkedIcon={<CheckCircleIcon color="success" />} />
                }
                label={label}
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Box sx={messageAfter} />
      </Box>
    </Box>
  );
};
